var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4484 16.4125C21.0467 17.575 22.1667 19.15 22.1667 21.25V25H26.8334V21.25C26.8334 18.525 22.6684 16.9125 19.4484 16.4125Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15C13.0773 15 15.1666 12.7614 15.1666 10C15.1666 7.23858 13.0773 5 10.5 5C7.92265 5 5.83331 7.23858 5.83331 10C5.83331 12.7614 7.92265 15 10.5 15Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15C20.0784 15 22.1667 12.7625 22.1667 10C22.1667 7.2375 20.0784 5 17.5 5C16.9517 5 16.4384 5.125 15.9484 5.3C16.9523 6.63027 17.5 8.28925 17.5 10C17.5 11.7107 16.9523 13.3697 15.9484 14.7C16.4384 14.875 16.9517 15 17.5 15ZM10.5 16.25C7.38502 16.25 1.16669 17.925 1.16669 21.25V25H19.8334V21.25C19.8334 17.925 13.615 16.25 10.5 16.25Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.09f90e94600bef3c4eb2f96759a0bae3.svg";
export { ForwardRef as ReactComponent };